export default "__VITE_ASSET__VKbRNtQO__"